import { Injectable } from '@angular/core';
import { BabylonGlobalModalI } from '@ctt-babylon/public-api';

@Injectable({
    providedIn: 'root',
})
export class DataInfoService {
    private newsletterDataV2: BabylonGlobalModalI | undefined;
    private offerPopupV3Data: BabylonGlobalModalI | undefined;
    private selectroModalData: any | undefined;

    constructor() {}

    public setNewsletterDataV2(data: BabylonGlobalModalI | undefined): void {
        this.newsletterDataV2 = data;
    }

    getNewsletterDataV2(): BabylonGlobalModalI | undefined {
        return this.newsletterDataV2;
    }

    public setOfferPopupV3Data(data: BabylonGlobalModalI | undefined): void {
        this.offerPopupV3Data = data;
    }

    getOfferPopupV3Data(): BabylonGlobalModalI | undefined {
        return this.offerPopupV3Data;
    }

    public setSelectroModalData(data: any | undefined): void {
        this.selectroModalData = data;
    }

    getSelectroModalData(): any | undefined {
        return this.selectroModalData;
    }
}
